import math from 'mathjs';

/**
 * 定义计算RSI指标类
 */
class RSI {
    /**
     * 计算RSI指标
     * @param {Array<Number>} closes 收盘价
     */
    constructor(closes = []) {
        this.closes = closes;
        this.increases = []; // 涨跌差值
        this.data = {};

        this.seriesOptions = [1, 2, 3].map(() => {
            return {
                type: 'line',
                data: [],
                xAxisIndex: 3,
                yAxisIndex: 3,
                showSymbol: false,
                lineStyle: {
                    width: 1
                }
            };
        });
    }

    /**
     * 按照指定日期序列逐个计算RSI指标
     * @param {Array<Number>} dayCounts 要计算的指定日期序列
     */
    calculate(dayCounts = [6, 12, 24]) {
        this.calculateAmountOfIncrease();

        dayCounts.forEach(dayCount => {
            this.data[dayCount.toString()] = this.calculateRSI(dayCount);
        });
    }

    /**
     * 计算涨跌值
     */
    calculateAmountOfIncrease() {
        this.increases = [];
        this.closes.forEach((close, index) => {
            if (index === 0) {
                this.increases.push(0);
                return;
            }

            let lastClose = this.closes[index - 1];
            this.increases.push(math.subtract(close, lastClose));
        });
    }

    /**
     * 计算指定日期范围内的RSI指标，并返回计算后的结果
     * @param {Number} dayCount 要计算的日期范围天数
     * @returns {Array<Number>} 返回计算后的结果
     */
    calculateRSI(dayCount = 12) {
        let result = [];
        let increaseSum = 0;
        let decreaseSum = 0;
        for (let i = 0; i < dayCount; i++) {
            let difference = this.increases[i];
            if (difference > 0) {
                increaseSum = math.add(increaseSum, difference);
            } else {
                decreaseSum = math.add(decreaseSum, math.abs(difference));
            }

            result.push(NaN);
        }
        // 计算n后面的值
        for (let i = dayCount; i < this.closes.length; i++) {
            let difference = this.increases[i];
            let increaseValue = 0;
            let decreaseValue = 0;

            if (difference > 0) {
                increaseValue = difference;
            } else {
                decreaseValue = math.abs(difference);
            }

            increaseSum = math.divide(math.add(math.multiply(increaseSum, dayCount - 1), increaseValue), dayCount);
            decreaseSum = math.divide(math.add(math.multiply(decreaseSum, dayCount - 1), decreaseValue), dayCount);

            let rsi = 0;
            if (decreaseSum > 0) {
                rsi = math.subtract(100, math.divide(100, math.add(1, math.divide(increaseSum, decreaseSum))));
            }

            result.push(rsi);
        }

        return result;
    }

    /**
     * 生成Series选项
     * @returns {Object} 返回生成的echarts的option对象
     */
    generateSeriesOption() {
        return Object.keys(this.data).map((key, index) => {
            let option = this.seriesOptions[index];
            option.name = 'RSI' + key;
            option.data = this.data[key];
            return option;
        });
    }
}

export default RSI;



// WEBPACK FOOTER //
// ./src/controller/series/RSI.js